import { http } from '@/http'

/**
 * Bitácora de conductores e historial de turnos de vehículos (DEF-ADM-011 v2.0).
 * Todas las vistas son de solo lectura.
 */
export default {
  // Bitácora del conductor en un rango de fechas (YYYY-MM-DD). tz = timezone IANA
  // de la ciudad activa: delimita el día en hora local (los timestamps son UTC).
  getDriverActivity(driverId, from, to, tz) {
    return http.get(`/api/v1/drivers/${driverId}/activity`, { params: { from, to, tz } })
  },

  // Resumen del día del conductor (turno, viajes, non show, cancelados).
  getDriverSummary(driverId, date, tz) {
    return http.get(`/api/v1/drivers/${driverId}/activity/summary`, { params: { date, tz } })
  },

  // Exporta la bitácora a Excel. Devuelve la respuesta completa (blob).
  exportDriverActivity(driverId, from, to, tz) {
    return http.get(`/api/v1/drivers/${driverId}/activity/export`, {
      params: { from, to, tz },
      responseType: 'blob'
    })
  },

  // Historial de turnos de un vehículo en un rango de fechas.
  getVehicleShifts(vehicleId, from, to) {
    return http.get(`/api/v1/vehicles/${vehicleId}/shifts`, { params: { from, to } })
  },

  // URL temporal (presigned) de la foto de inicio de turno.
  getShiftPhoto(shiftId) {
    return http.get(`/api/v1/shifts/${shiftId}/photo`)
  },

  // URL temporal (presigned) de la foto del odómetro (type = 'start' | 'end').
  getOdometerPhoto(shiftId, type) {
    return http.get(`/api/v1/shifts/${shiftId}/odometer-photo`, { params: { type } })
  }
}
